import { Outlet } from 'react-router-dom';
import { TagGeneratingFilesProvider } from '@/screens/Workspace.FilesTable/TagGeneratingFilesProvider';

export const WorkspaceLayout = () => {
  return (
    <TagGeneratingFilesProvider>
      <Outlet />
    </TagGeneratingFilesProvider>
  );
};